(ns common.widgets.markdown
  (:require ["@mui/material/Link$default" :as Link]
            ["@mui/material/Typography$default" :as Typography]
            ["react-markdown$default" :as ReactMarkdown]
            ["rehype-raw$default" :as rehypeRaw]
            ["remark-gfm$default" :as remarkGfm]
            [clojure.string :as str]
            [uix.core :as uix :refer [$ defui]]))

(def header-fn
  (uix/as-react
   (fn [{:keys [level children] :as props}]
     ($ Typography (merge props
                          {:id (str/replace (first children) " " "_")
                           :variant (str "h" level)
                           :gutterBottom true})))))

(def components
  #js {:h1 header-fn
       :h2 header-fn
       :h3 header-fn
       :h4 header-fn
       :h5 header-fn
       :td (uix/as-react
            (fn [props]
              ($ :td (merge (dissoc props :isHeader)
                            {:style {:padding "8px"}}))))
       :th (uix/as-react
            (fn [props]
              ($ :th (merge (dissoc props :isHeader)
                            {:style {:padding "8px"
                                     :white-space "nowrap"
                                     :font-weight 600}}))))
       :p (uix/as-react
           (fn [props]
             ($ Typography (merge props {:paragraph true}))))
       :a (uix/as-react
           (fn [props]
             ($ Link (merge props {:target "_blank"}))))})

(defui markdown [{:keys [children] :as props}]
  ($ ReactMarkdown
     (merge {:components components
             :remarkPlugins #js [remarkGfm]
             :rehypePlugins #js [rehypeRaw]}
            props)
     children))
